import React from "react";

// Lightweight, reusable "stack of photo magnets" visual. Purely decorative so it
// never competes with price / CTA. Pass `images` (1-3 urls) to show real photos;
// otherwise it renders tasteful brand-tinted magnet shapes.
const TINTS = [
  "hsl(var(--brand-blush))",
  "hsl(var(--brand-rose))",
  "hsl(var(--brand-cream))",
];

export const ProductStack = ({ images = [], className = "", size = 56 }) => {
  const tiles = [0, 1, 2];
  const offsets = [
    { left: 0, top: 6, rot: -8, z: 1 },
    { left: size * 0.42, top: 0, rot: 4, z: 3 },
    { left: size * 0.84, top: 8, rot: 10, z: 2 },
  ];
  return (
    <div
      className={`relative ${className}`}
      style={{ width: size * 1.84 + size, height: size + 16 }}
      aria-hidden="true"
    >
      {tiles.map((i) => {
        const o = offsets[i];
        const img = images[i];
        return (
          <div
            key={i}
            className="absolute overflow-hidden"
            style={{
              width: size, height: size, left: o.left, top: o.top, zIndex: o.z,
              borderRadius: "22%",
              transform: `rotate(${o.rot}deg)`,
              background: img ? "transparent" : TINTS[i % TINTS.length],
              boxShadow: "0 6px 14px rgba(74,42,39,0.18)",
              border: "2px solid #fff",
            }}
          >
            {img ? <img src={img} alt="" className="h-full w-full object-cover" /> : null}
            <span
              className="pointer-events-none absolute inset-0"
              style={{ background: "linear-gradient(135deg, rgba(255,255,255,0.4), rgba(255,255,255,0) 45%)" }}
            />
          </div>
        );
      })}
    </div>
  );
};
